import { useContext } from 'react';
import { ModalContext, IModalContext } from 'contexts/modal';
import { UserContext, IUserContext } from 'contexts/user';
import { GTM_CLICK_HOMEPAGE_SOLD_SIGN_IN } from 'constants/events';
import { trackEvent } from 'utils/google-tag-manager';

interface OnListingCardClickOptions {
  isHomePage?: boolean;
}

export interface OnListingCardCLickProps {
  event?: unknown;
  isNoModalLocation?: boolean;
  addressPathWithFallback: string;
  listingId?: number;
  showsListing?: boolean;
  isPrivate: boolean;
  isSignInAndTermsOfUseRequired: boolean;
  isTermsRequired?: boolean;
  providerId?: number;
}

export function useOnListingCardClick({ isHomePage = false }: OnListingCardClickOptions = {}) {
  const { openModal } = useContext(ModalContext) as IModalContext;
  const { isAuthenticated } = useContext(UserContext) as IUserContext;

  const openAddressPathWithFallback = (addressPathWithFallback: string) => {
    window.open(addressPathWithFallback, '_blank');
  };

  const openProviderModal = (providerId: number) => {
    openModal('terms-of-use', { providerId });
  };

  const openAuthModal = () => {
    openModal('login-registration');
  };

  const openListingModal = (addressPathWithFallback: string, listingId?: number) => {
    openModal('listing', { externalUrl: addressPathWithFallback, listingId });
  };

  if (isHomePage) {
    const homePageClickFunction = ({ addressPathWithFallback, isPrivate, isSignInAndTermsOfUseRequired, isTermsRequired, providerId }: OnListingCardCLickProps) => {
      if ((isSignInAndTermsOfUseRequired || isPrivate) && !isAuthenticated) {
        openAuthModal();
        trackEvent('Sold_Prices_Overlay');
        trackEvent(GTM_CLICK_HOMEPAGE_SOLD_SIGN_IN);
        if (isTermsRequired && providerId) {
          openProviderModal(providerId);
        }
      }
      else if (isTermsRequired && providerId) {
        openProviderModal(providerId);
      }
      else {
        openAddressPathWithFallback(addressPathWithFallback);
      }
    };
    return homePageClickFunction;
  }

  else {
    const listingCardClickFunction = ({ event, isNoModalLocation, addressPathWithFallback, listingId, showsListing, isPrivate, isSignInAndTermsOfUseRequired }: OnListingCardCLickProps) => {
      if (isPrivate || ((isSignInAndTermsOfUseRequired || !showsListing) && !isAuthenticated)) {
        openListingModal(addressPathWithFallback, listingId);
      }
      else if (isNoModalLocation) {
        openAddressPathWithFallback(addressPathWithFallback);
      }
      else if (((event as MouseEvent).target as Element).tagName !== 'A') {
        openListingModal(addressPathWithFallback, listingId);
      }
    };
    return listingCardClickFunction;
  }
}